export default "__VITE_ASSET__C92riMQm__"